import { createSlice } from "@reduxjs/toolkit";
import {
  getAllUsers,
  deleteUserById,
  getUserById,
  UpdateUserById,
  activateDeactivateUser,
} from "../actions/user.actions";

const initialState = {
  data: null,
  isLoading: false,
  isSuccess: false,
  errorMessage: "",
};

export const userSlice = createSlice({
  name: "issues",
  initialState,
  extraReducers: {
    [getAllUsers.pending]: (state) => {
      state.isLoading = true;
    },
    [getAllUsers.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = payload;
    },
    [getAllUsers.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
    },
    [getUserById.pending]: (state) => {
      state.isLoading = true;
    },

    [getUserById.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = payload;
    },
    [getUserById.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
      state.data = null;
    },
    [deleteUserById.pending]: (state) => {
      state.isLoading = true;
      state.isSuccess = false;
    },
    [deleteUserById.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [deleteUserById.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
    },

    [UpdateUserById.pending]: (state) => {
      state.isLoading = true;
    },
    [UpdateUserById.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = { result: payload.result.data };
    },
    [UpdateUserById.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
      state.data = null;
    },

    [activateDeactivateUser.pending]: (state) => {
      state.isLoading = true;
    },
    [activateDeactivateUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [activateDeactivateUser.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.errorMessage = payload;
      state.data = null;
    },
  },
});

export default userSlice.reducer;
